import { PayViaEnum } from './data';

export const AppRoutes = {
  HomePage: '/',
  Login: '/login',
  Test: '/test',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',

  Contacts: '/contacts',
  ContactsList: '/contacts/list',
  ContactsFindAPhone: '/contacts/find-a-phone',

  Shortlink: '/shortlink',
  ShortLinkTab: '/shortlink/main',
  ShortLinkSmsToPhoneTab: '/shortlink/sms-to-phone',

  ContactsBlackList: '/black-list',

  User: '/user',
  UserList: '/user/list',
  UserPriceTable: '/user/price-table',
  UserSubAccount: '/user/sub-account',
  UserCredits: '/user/credits',
  UserPermission: '/user/permission',

  PremiumServices: '/premium-service',
  PremiumServicesListOrder: '/premium-service/list-order',
  PremiumServicesListActive: '/premium-service/list-active',

  AutomationTest: '/automation-test',
  CloneUserData: '/clone-user-data',

  RouteMarketing: '/route-management',
  Route: '/route-management/route',
  RouteFinder: '/route-management/route-finder',
  SubscriptionPlan: '/route-management/subscription-plan',
  VendorDefaultPrice: '/route-management/vendor-default-price',
  VendorSettings: '/route-management/vendor-settings',
  VendorAccount: '/route-management/vendor-account',
  SIPConnections: '/route-management/sip-connections',
  Marketing: '/route-management/marketing',

  Did: '/did',
  DidManagement: '/did/management',
  DidHistory: '/did/history',
  DidVirtualDid: '/did/virtual-did',
  DidPurchaseNumberPool: '/did/purchase-number-pool',
  MigrateDID: '/did/migration',

  Device: '/device',
  DeviceDidManagement: '/device/did-management',
  DidDevicePool: '/device/device-pool',
  DeviceMaps: '/device/maps',

  FarmManagement: '/farm-management',
  FarmManagementApp: '/farm-management/app',
  FarmManagementFarm: '/farm-management/farm',

  Inbox: '/inbox',

  //* TA-5855: https://textback.atlassian.net/browse/TA-5855
  Dids: '/dids',

  Campaign: '/campaign',

  //! Finance
  Finance: '/finance',
  FinanceTab: '/finance/main',
  FinanceReportingTab: '/finance/reporting',
  FinanceCreditInventory: '/finance/inventory',
  FinanceCreditRequest: '/finance/credit-requests',

  Invoice: '/finance/invoice',
  InvoiceList: '/finance/invoice/list',
  InvoiceDetail: '/finance/invoice/:id',
  InvoiceDetailWithId: (id, type) =>
    `/finance/invoice/${id}?type=${type || PayViaEnum.BankTransfer}`,

  Tickets: '/tickets',
  TicketsDetail: '/tickets/:id',
  TicketsDetailWithId: (id) => `/tickets/${id}`,
  TicketCreate: '/tickets/create',

  ManagementGuide: '/management-guide',
  ManagementGuideEdit: '/management-guide/edit',
  ManagementGuideEditRole: '/management-guide/edit/:role',
  ManagementGuideEditWithRole: (role) => `/management-guide/edit/${role}`,
  Guide: '/guide',

  RoleManagement: '/role-management',
  Role: '/role-management/role',
  Permission: '/role-management/permission',

  SimManagement: '/sim-management',
  SimManagementList: '/sim-management/list',
  SimInventory: '/sim-management/inventory',
  SimStats: '/sim-management/stats',
  SimHistory: '/sim-management/history',
  SimPool: '/sim-management/pool',

  TenDLC: '/10-dlc',
  TenDLCDetail: '/10-dlc/:id',
  TenDLCDetailWithId: (id) => `/10-dlc/${id}`,

  TenDLCUseCase: '/10-dlc/:idBrand/use-case/:idUseCase',
  TenDLCUseCaseWithId: (idBrand, idUseCase) => `/10-dlc/${idBrand}/use-case/${idUseCase}`,

  History: '/history',

  SendEmail: '/send-email',
  SystemConfig: '/system-config',
  SystemConfigMain: '/system-config/main',
  SystemConfigBlockIP: '/system-config/ip',

  CarrierInbound: '/carrier',
  CarrierInboundMain: '/carrier/main',
  CarrierInboundMnoCarrier: '/carrier/mno-carrier',
  CarrierInboundMCCMNCMapping: '/carrier/mnc-mcc-mapping',
  CarrierInboundMCCMNCLogChanges: '/carrier/change-logs',

  KYC: '/kyc',

  Services: '/services',
  BackgroundProcess: '/services/process',
  ServicesStatus: '/services/status',
  VendorsStatus: '/services/vendors-status',
  AlertSystem: '/services/alert-system',
  AMDVisualizeStats: '/services/amd-visualize-stats',

  VersionManagement: '/versionManagement',

  CompareStats: '/statistics',
  CompareStatsMain: '/statistics/main',

  ModemManagement: '/modem-management',

  Traffic: '/traffic',

  ErrorTracker: '/error-tracker',
  ErrorTrackerList: '/error-tracker/list',

  Creatives: '/creatives',
  CreativesAssistant: '/creatives/assistant',
  CreativesRequest: '/creatives/list',

  AudioBuilder: '/audio',
  AudioBuilderVoiceSetting: '/audio/voice-setting',
  AudioBuilderApproval: '/audio/spintax-approval',

  TFN: '/tfn',
  TFNCreate: '/tfn/create',
  TFNDetail: '/tfn/:id',
  TFNDetailWithId: (id) => `/tfn/${id}`,

  TFNEdit: '/tfn/:id/edit',
  TFNEditWithId: (id) => `/tfn/${id}/edit`,

  Layout: '/layout',

  Referral: '/referral',
  ReferralProgramList: '/referral/program',
  ReferralLayout: '/referral/layout',

  PerformanceTracker: '/performance-tracker',
  PerformanceTrackerDID: '/performance-tracker/did',
  PerformanceTrackerDomain: '/performance-tracker/domain',
  PerformanceUserTracker: '/performance-tracker/users-behavior',

  //* Marketplace
  Marketplace: '/marketplace',
  MarketplaceList: '/marketplace/list',
  MarketplacePurchasedProduct: '/marketplace/purchased-product',

  //* Certing vertical
  CertingVertical: '/certing-vertical',
  CertingVerticalList: '/certing-vertical/list',

  //* Domains group
  DomainGroup: '/domain-group',
  DomainGroupList: '/domain-group/list',
  DomainGroupTransfer: '/domain-group/transfer',

  //* Chatbot
  AI: '/ai',
  AIChatbot: '/ai/chat-bot',
  AICreative: '/ai/creative',
  AIChatHistory: '/ai/chat-history',
  AISystemPrompt: '/ai/system-prompt',

  //* Responder
  Responder: '/responder',
  ResponderTemplate: '/responder/template',

  //* SMPP
  SMPP: '/smpp',
  SMPPMonitoring: '/smpp/monitoring',

  //* Change requests
  ChangeRequests: '/change-requests',
  ChangeRequestsRoute: '/change-requests/route-price',
  ChangeRequestsVendor: '/change-requests/vendor-price',
  ChangeRequestsInvoice: '/change-requests/invoice-release',
  ChangeRequestsBillingInformation: '/change-requests/billing-info',

  //* Tutorial
  Tutorial: '/tutorial',

  //* Transcription
  Transcription: '/transcription',
};
